module.exports = __webpack_public_path__ + "img/layout_fish_right.f503822b.svg";